import React from 'react'
import Walkthrough from '../../../../../App/models/Walkthrough'
import PublicStepList from './PublicStepList'
import PublicWalkthroughHeader from './PublicWalkthroughHeader'

interface Props {
  walkthrough: Walkthrough
  steps: any[]
}

const PublicViewer: React.FC<Props> = ({ walkthrough, steps }) => (
  <>
    <div className="w-full">
      <PublicWalkthroughHeader walkthrough={walkthrough} steps={steps} />
      <div className="max-w-7xl mx-auto px-8">
        <div className="lg:block bg-white border rounded-md relative p-8">
          <PublicStepList canEditWalkthrough={false} steps={steps} usePublicEndpoint={true} />
        </div>
      </div>
    </div>
  </>
)

export default PublicViewer
